import React, { useCallback } from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from '@mui/material';
import {
  EPolicyFields,
  EPolicySeverity,
  SEVERITIES_RANGE_LIST,
} from '../../types/policies-types';
import { updateProfilePolicyProps } from '../../actions/policies-profile-actions/policy-state-actions';
import { MenuProps } from '../DynamicArgs/constants';
import { enablePoliciesSaveButton } from '../../actions/policies-selection-ui-actions/policies-selection-ui-actions';

interface IssueSeverityDropDownProps {
  severity: EPolicySeverity;
  id: string;
}

const IssueSeverityDropDown: React.FC<
  React.PropsWithChildren<IssueSeverityDropDownProps>
> = ({ severity, id }) => {
  const handleChange = useCallback(
    (event: SelectChangeEvent<EPolicySeverity>) => {
      event.stopPropagation();
      enablePoliciesSaveButton(true);

      const value = event.target.value as EPolicySeverity;
      updateProfilePolicyProps({
        id,
        field: EPolicyFields.displayIssueSeverity,
        value,
      });
    },
    [id],
  );

  return (
    <FormControl size='small'>
      <InputLabel htmlFor={EPolicyFields.displayIssueSeverity}>
        <Typography variant='body1'>Show issues of severity</Typography>
      </InputLabel>
      <Select
        label='Show issues of severity'
        className='policy-severity-box'
        size='small'
        name={EPolicyFields.displayIssueSeverity}
        value={severity}
        renderValue={selected => (
          <Typography
            color={SEVERITIES_RANGE_LIST.find(s => s.value === selected)?.color}
            lineHeight='unset'
            variant='body2'>
            {SEVERITIES_RANGE_LIST.find(s => s.value === selected)?.displyName}
          </Typography>
        )}
        sx={{
          minWidth: 218,
          paddingLeft: '2px',
        }}
        onChange={handleChange}
        MenuProps={MenuProps}>
        {SEVERITIES_RANGE_LIST.map(({ displyName, value, color }) => {
          return (
            <MenuItem
              key={value}
              onClick={e => e.stopPropagation()}
              value={value}>
              <Typography color={color} variant='body2'>
                {displyName}
              </Typography>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default IssueSeverityDropDown;
